// PANAS types and interfaces
export type Answers = { [row: string]: number }

export type BasicReport = {
  positiveThoughts: string
  forgiveOthers: string
  forgiveSelf: string
  releaseTrauma: string
  fearOrWorry: string
  wantToBeWell: keyof typeof panasBasicOptions | ''
  believeCanGetWell: keyof typeof panasBasicOptions | ''
  safeToGetWell: keyof typeof panasBasicOptions | ''
  safeForOthersGetWell: keyof typeof panasBasicOptions | ''
  readyToGetWell: keyof typeof panasBasicOptions | ''
  willingToGetWell: keyof typeof panasBasicOptions | ''
  ableToGetWell: keyof typeof panasBasicOptions | ''
  deserveToGetWell: keyof typeof panasBasicOptions | ''
  takingAction: keyof typeof panasBasicOptions | ''
}

export type PANASSectionReport = {
  answers: Answers
  positive: number
  negative: number
  net: number
  complete: boolean
}

export type PANASReport = {
  main: PANASSectionReport
  supplemental: PANASSectionReport
  basic?: BasicReport
  copiedFromLastMonth?: boolean
  modifiedPanas?: PANASSectionReport
}

export const panasBasicOptions = {
  yes: 'Yes',
  maybe: 'Maybe',
  no: 'No',
}

export const basicDefault: BasicReport = {
  ableToGetWell: '',
  believeCanGetWell: '',
  deserveToGetWell: '',
  forgiveOthers: '',
  forgiveSelf: '',
  positiveThoughts: '',
  readyToGetWell: '',
  releaseTrauma: '',
  safeForOthersGetWell: '',
  safeToGetWell: '',
  wantToBeWell: '',
  willingToGetWell: '',
  fearOrWorry: '',
  takingAction: '',
}
